import Form from 'react-bootstrap/Form';
import ProfileRoleForm from './forms/ProfileRoleForm';
import ProfileEmailForm from './forms/ProfileEmailForm';
import ProfileFullNameForm from './forms/ProfileFullNameForm';
import ProfilePermissionsForm from './forms/ProfilePermissionsForm';
import ProfileChangePasswordForm from './forms/ProfileChangePasswordForm';

function ProfileFormController({ setSpinner }) {
  return (
    <Form>
      <Form.Group className="d-flex flex-column">
        <ProfileFullNameForm setSpinner={setSpinner} />
        <ProfileEmailForm />
        <ProfileRoleForm />
        <ProfilePermissionsForm setSpinner={setSpinner} />
        <ProfileChangePasswordForm setSpinner={setSpinner} />
      </Form.Group>
    </Form>
  );
}

export default ProfileFormController;
